import request from "@/utils/request";
import config from "@/utils/config";

/**
 * 后台添加菜单
 * @param data
 * @returns {*}
 */
export function addMenu(data) {
    return request({
        url: config.API_AUTH + "/auth/v1/menu/add",
        method: "post",
        data,
    });
}

/**
 * 查询系统可用的菜单列表
 * @param data
 * @returns {*}
 */
export function getAvailableList() {
    return request({
        url: config.API_AUTH + "/auth/v1/menu/availableList",
        method: "get",
    });
}

/**
 * 后台删除菜单
 * @param data
 * @returns {*}
 */
export function deleteMenu(data) {
    return request({
        url: config.API_AUTH + "/auth/v1/menu/delete",
        method: "delete",
        data,
    });
}

/**
 * 分页查询所有菜单列表
 * @param params
 * @returns {*}
 */
export function getMenuList(params) {
    return request({
        url: config.API_AUTH + "/auth/v1/menu/list",
        method: "get",
        params,
    });
}

/**
 * 后台角色绑定菜单
 * @param params
 * @returns {*}
 */
export function menuRoleBind(params) {
    return request({
        url: config.API_AUTH + "/auth/v1/menu/role/bind",
        method: "post",
        data:params,
    });
}


/**
 * 后台更新菜单
 * @param params
 * @returns {*}
 */
export function updateMenu(params) {
    return request({
        url: config.API_AUTH + "/auth/v1/menu/update",
        method: "post",
        data:params,
    });
}

/**
 * 查询当前用户可查看的菜单列表
 * @param params
 * @returns {*}
 */
export function getUserAvailableMenuList(params) {
    return request({
        url: config.API_AUTH + "/auth/v1/menu/user/availableList",
        method: "get",
        params:params,
    });
}

/**
 * 查询指定用户角色绑定的菜单列表
 * @param params
 * @returns {*}
 */
export function getUserRoleAvailableMenuList(params) {
    return request({
        url: config.API_AUTH + "/auth/v1/menu/role/bindList",
        method: "get",
        params:params,
    });
}